import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const from = ['"What am I teaching tomorrow?"', 'Searching across multiple resources', 'Rebuilding classes every week', 'Repeating the same exercises', 'Improvising progressions', 'Spending personal time planning'];
const to = ['250+ exercises organized for you', '100 sessions ready to use', 'Clear progression options', '12 months of programming', 'Professional planning tools', 'One organized coaching system'];
export function TransformSection() {
  return <section className="bg-ivory px-4 sm:px-6 py-9 sm:py-12" data-id="element-186" data-mp="3i3omkkk3bun8">
      <div className="max-w-3xl mx-auto" data-id="element-187" data-mp="345hw3phh0wxl">
        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight text-petrol text-center mb-3.5" data-id="element-188" data-mp="346t09qetw6p8">
          Think about your next 4 weeks of classes.
        </h2>

        <div className="text-[13px] sm:text-base text-petrol/70 leading-relaxed text-center max-w-xl mx-auto mb-3" data-id="element-189" data-mp="1srw9oc2zx9fr">
          <p data-id="element-190" data-mp="1do7o07ux3i1f">You could keep searching for exercises...</p>
          <p data-id="element-191" data-mp="1doptlv3gz8m0">Building sessions one by one...</p>
          <p data-id="element-192" data-mp="19mvys3fygytr">Organizing progressions manually...</p>
          <p data-id="element-193" data-mp="19o74w9wviio1">And repeating the same process next month.</p>
        </div>

        <p className="text-[13px] sm:text-base text-petrol/70 leading-relaxed text-center max-w-xl mx-auto mb-3.5" data-id="element-194" data-mp="1nnf2iyde1iq4">
          Or you could open one system and already have a professional starting
          point waiting for you.
        </p>

        <p className="font-heading font-extrabold uppercase text-sm sm:text-lg tracking-tight text-green-dark text-center mb-6" data-id="element-195" data-mp="1wkz5qcut9p3d">
          That's what Fitness Senior Ready™ changes.
        </p>

        <div className="grid grid-cols-2 gap-2.5" data-id="element-196" data-mp="26ezin0wc3ymn">
          <div className="bg-white border border-petrol/10 rounded-lg p-3.5 sm:p-5" data-id="element-197" data-mp="21dikve95csaa">
            <h3 className="font-heading font-extrabold uppercase text-[11px] sm:text-sm tracking-[0.14em] text-petrol/40 mb-2.5 pb-2 border-b border-petrol/10" data-id="element-198" data-mp="2gajclhrc8n8r">
              From:
            </h3>
            <ul className="flex flex-col gap-2" data-id="element-199" data-mp="2ifoe9s8jng8t">
              {from.map(item => <li key={item} className="flex items-start gap-1.5" data-id="element-200" data-mp="2ndznq1uxfoqi">
                  <XIcon className="w-3 h-3 text-petrol/35 mt-0.5 shrink-0" data-id="element-201" data-mp="2nc6eqfwucsfc" />
                  <span className="text-[11px] sm:text-sm text-petrol/60 leading-snug" data-id="element-202" data-mp="2sbregsju54t4">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white border-2 border-green rounded-lg p-3.5 sm:p-5 shadow-md" data-id="element-203" data-mp="322m509446qkd">
            <h3 className="font-heading font-extrabold uppercase text-[11px] sm:text-sm tracking-[0.14em] text-green-dark mb-2.5 pb-2 border-b border-green/20" data-id="element-204" data-mp="3635zf4xazg2t">
              To:
            </h3>
            <ul className="flex flex-col gap-2" data-id="element-205" data-mp="3g2enxi9eg2hs">
              {to.map(item => <li key={item} className="flex items-start gap-1.5" data-id="element-206" data-mp="1gquafwd8p0p8">
                  <CheckIcon className="w-3 h-3 text-green mt-0.5 shrink-0" data-id="element-207" data-mp="1lonlp3tegkwd" />
                  <span className="text-[11px] sm:text-sm font-medium text-petrol leading-snug" data-id="element-208" data-mp="1lqqf7xtrgw5u">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}